import Dialog from "./Dialog";

function ConfirmModal({ isOpen, title, message, onConfirm, onCancel }) {
  if (!isOpen) return null;

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onCancel}
      panelClassName="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl"
    >
      {({ titleId }) => (
        <div>
          <h3 id={titleId} className="text-base font-semibold text-gray-900">
            {title || "Confirm action"}
          </h3>
          <p className="mt-2 text-sm text-gray-500">{message}</p>

          <div className="mt-6 flex gap-3">
            <button
              onClick={onConfirm}
              className="flex-1 rounded-lg bg-red-600 py-2.5 text-sm font-medium text-white transition-colors hover:bg-red-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-400"
              data-autofocus
            >
              Yes, remove
            </button>
            <button
              onClick={onCancel}
              className="flex-1 rounded-lg border border-gray-300 py-2.5 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#282E6A]"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </Dialog>
  );
}

export default ConfirmModal;
